import { __exports as utils } from "../../../_virtual/utils.js";
import { e as exenvExports } from "../../exenv/index.js";
Object.defineProperty(utils, "__esModule", {
  value: true
});
utils.pipe = utils.listenerOptions = void 0;
utils.preventTouchMove = preventTouchMove;
utils.allowTouchMove = allowTouchMove;
utils.preventInertiaScroll = preventInertiaScroll;
utils.isTouchDevice = isTouchDevice;
utils.camelToKebab = camelToKebab;
utils.parse = parse;
utils.getPadding = getPadding;
utils.getWindowHeight = getWindowHeight;
utils.getDocumentHeight = getDocumentHeight;
utils.makeStyleTag = makeStyleTag;
utils.injectStyles = injectStyles;
utils.insertStyleTag = insertStyleTag;
var _exenv = exenvExports;
utils.listenerOptions = {
  capture: false,
  passive: false
};
function preventTouchMove(e) {
  e.preventDefault();
  return false;
}
function allowTouchMove(e) {
  var target = e.currentTarget;
  if (target.scrollHeight > target.clientHeight) {
    e.stopPropagation();
    return true;
  }
  e.preventDefault();
  return false;
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}
function isTouchDevice() {
  if (!_exenv.canUseDOM)
    return false;
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function parse(val) {
  return isNaN(val) ? val : val + "px";
}
var pipeFns = function pipeFns2(a, b) {
  return function() {
    return b(a.apply(void 0, arguments));
  };
};
utils.pipe = function pipe() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return fns.reduce(pipeFns);
};
function getPadding() {
  if (!_exenv.canUseDOM)
    return 0;
  var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  return paddingRight + scrollbarWidth;
}
function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
  if (_exenv.canUseDOM) {
    return window.innerHeight * multiplier;
  }
}
function getDocumentHeight() {
  if (_exenv.canUseDOM) {
    return document.body.clientHeight;
  }
}
function makeStyleTag() {
  if (!_exenv.canUseDOM)
    return;
  var tag = document.createElement("style");
  tag.type = "text/css";
  tag.setAttribute("data-react-scrolllock", "");
  return tag;
}
function injectStyles(tag, css) {
  if (!_exenv.canUseDOM)
    return;
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  if (!_exenv.canUseDOM)
    return;
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
export {
  utils as default
};
//# sourceMappingURL=utils.js.map
